import * as React from 'react';
import { PathnameContext } from 'src/contexts/pathname-context';

export function usePathname() {
  return React.useContext(PathnameContext);
}

export default usePathname;
